import { useEffect, useState } from 'react';

// Returns `value` after it has been stable for `delayMs`. Used to debounce
// typeahead queries before firing API requests.
export default function useDebouncedValue(value, delayMs = 250) {
    const [debounced, setDebounced] = useState(value);
    useEffect(() => {
        const timer = setTimeout(() => setDebounced(value), delayMs);
        return () => clearTimeout(timer);
    }, [value, delayMs]);
    return debounced;
}
